import angular from "angular";
import SignupController from "./signup.controller";
import StudentSignup from "./student/student-signup.module";
import InstructorSignup from "./instructor/instructor-signup.module";
import StaffSignup from "./staff/staff-signup.module";
import template from "./signup.html";
function config($stateProvider, $urlRouterProvider) {
  $stateProvider.state("drivecoach.signup", {
    url: "/signup",
    controller: SignupController,
    template: template,
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];

export default angular
  .module("signup", [
    StudentSignup.name,
    InstructorSignup.name,
    StaffSignup.name,
  ])
  .controller("SignupController", SignupController)
  .config(config);
